<!-- 咖啡问卷已提交 -->
<template>
  <div class="submitted">
    <div class="text-content">
      <div class="mobile">恭喜{{ formatPhone(mobile) }}成功提交问券</div>
      <div class="free">
        您可免费获得
        一杯大杯咖啡！
      </div>
    </div>
    <img src="../../../../assets/img/events/coffee/pic_congratulate@3x.png">
    <div class="submitted-button">
      <span @click="back()">已提交</span>
    </div>
  </div>
</template>

<script>
import { getUserData } from "@/common/api/events";
export default {
  data() {
    return {
      mobile: ""
    };
  },

  created() {
    this.getUserData();
  },

  methods: {
    formatPhone(mobile) {
      return mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    },

    getUserData() {
      getUserData().then(resp => {
        let data = resp.data;
        if (data.code === 0) {
          this.mobile = data.data.mobile;
        }
      });
    },

    back() {
      this.$router.push({ path: "/delicacy/" });
    }
  }
};
</script>
<style lang='scss' scoped>
@import "../../../../assets/css/px2rem.scss";

.submitted {
  padding-top: px2rem(40);
  background: #f06050;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  img {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  .text-content {
    width: px2rem(210);
    color: #fff;
    position: absolute;
    top: 20%;
    left: 10%;
    font-weight: 300;
    .mobile {
      font-size: px2rem(14);
    }
    .free {
      font-size: px2rem(30);
    }
  }
  .submitted-button {
    text-align: center;
    position: absolute;
    width: 100%;
    bottom: 5%;
    span {
      display: inline-block;
      height: px2rem(34);
      line-height: px2rem(34);
      width: px2rem(120);
      border: px2rem(1) solid #fff;
      background-color: transparent;
      font-size: px2rem(14);
      color: #fff;
    }
  }
}
</style>
